import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import FormField from "components/FormField";
import MDBox from "components/MDBox";
import { useAuthContext } from "context/AuthContext";
import { useState } from "react";

const CooperatedFormDescription = ({
  label,
  cooperated,
  pas,
  pa,
  setPa,
  status,
  setStatus,
  reason,
  setReason,
  situationDocument,
  setSituationDocument,
  setInput,
}) => {
  const [step, setStep] = useState(false);

  const { user } = useAuthContext();

  const [inputPa, setInputPa] = useState("");
  const [inputStatus, setInputStatus] = useState("");
  const [inputSituationDocument, setInputSituationDocument] = useState("");

  const optionsSituationDocument = ["Liberada", "Restrita"];
  let optionsStatus = [];

  if (!status || status === 1) {
    optionsStatus = [
      "Em aberto",
      "Iniciado",
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
    ];
  } else if (status === 2) {
    optionsStatus = [
      "Iniciado",
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
    ];
  } else {
    optionsStatus = [
      "Em análise",
      "Aguardando Assinatura",
      "Finalização Cadastral",
      "Documentos pendentes",
      "Em processo admissão",
      "Aprovado",
      "Reprovado",
    ];
  }

  const optionsReason = [
    "Inconsistência de dados",
    "Prazo de envio de documentos excedido",
    "Já é cooperado",
  ];

  const reasons = (res) => {
    switch (res) {
      case 1:
        return "Inconsistência de dados";
      case 2:
        return "Prazo de envio de documentos excedido";
      case 3:
        return "Já é cooperado";
      default:
        return res;
    }
  };

  const PA = (pa_uuid) => pas.filter((obj) => obj?.uuid === pa_uuid)[0];

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <Autocomplete
                value={pa ?? PA(pa) ?? ""}
                onChange={(_, newValue) => {
                  setPa(newValue);
                }}
                inputValue={inputPa}
                onInputChange={(_, newInputValue) => {
                  setInputPa(newInputValue);
                }}
                getOptionLabel={(pa) =>
                  pa ? `${pa?.number} - ${pa?.name}` : ""
                }
                options={pas}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Selecione o P.A."
                    required
                  />
                )}
              />

              {user?.profile === 1 && user?.company_id && (
                <FormField
                  type="text"
                  label="Descrição Privada"
                  name="private_description"
                  value={cooperated?.private_description}
                  multiline
                  rows={5}
                  placeholder="Descrição Privada"
                  onChange={setInput}
                />
              )}

              {user?.profile === 99 && (
                <>
                  <Autocomplete
                    value={situationDocument}
                    onChange={(_, newValue) => {
                      setSituationDocument(newValue);
                    }}
                    inputValue={inputSituationDocument}
                    onInputChange={(_, newInputValue) => {
                      setInputSituationDocument(newInputValue);
                    }}
                    options={optionsSituationDocument}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Situação CPF"
                      />
                    )}
                  />

                  <Autocomplete
                    value={status}
                    onChange={(_, newValue) => {
                      setStatus(newValue);
                    }}
                    inputValue={inputStatus}
                    onInputChange={(_, newInputValue) => {
                      setInputStatus(newInputValue);
                    }}
                    options={optionsStatus}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Status da conta"
                      />
                    )}
                  />

                  {status === "Reprovado" && (
                    <Autocomplete
                      value={reason ?? reasons(reason)}
                      onChange={(_, newValue) => {
                        setReason(newValue);
                      }}
                      inputValue={reason}
                      onInputChange={(_, newInputValue) => {
                        setReason(newInputValue);
                      }}
                      options={optionsReason}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Motivo da reprovação"
                          required={status === "Reprovado"}
                        />
                      )}
                    />
                  )}

                  {status === "Reprovado" && reason === "Já é cooperado" && (
                    <FormField
                      type="text"
                      label="Número da conta"
                      name="account_number"
                      value={cooperated?.account_number}
                      placeholder="Número da conta"
                      required={
                        status === "Reprovado" && reason === "Já é cooperado"
                      }
                      onChange={setInput}
                    />
                  )}

                  {status === "Aprovado" && (
                    <FormField
                      type="text"
                      label="Número da conta"
                      name="account_number"
                      value={cooperated?.account_number}
                      placeholder="Número da conta"
                      required={status === "Aprovado"}
                      onChange={setInput}
                    />
                  )}
                </>
              )}
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormDescription;
